import { LEADERSHIP_NAV_TITLE } from "src/web/constants";

export interface Step {
    readonly title: string;
    readonly detail: string;
}

export const STEPS: readonly Step[] = [
    {
        title: "Discover your packages",
        detail:
            "Scans each onboarded pipeline to fetch the packages it builds, along with " +
            "version set and branch information.",
    },
    {
        title: "Collect dependencies",
        detail:
            "Reads every package to gather its dependencies. Library, runtime, and test " +
            "dependencies are covered; build tools are not scanned.",
    },
    {
        title: "Apply vendor guidance",
        detail:
            "Periodically checks for new releases and updated guidance, then decides which " +
            "dependencies are worth upgrading and to which version.",
    },
    {
        title: "Verify the upgrade builds",
        detail:
            "Performs a basic test of the change by building the package and running its " +
            "unit tests before anything reaches you.",
    },
    {
        title: "Raise the code review",
        detail:
            "Submits a code review your team can review and merge. Minor version upgrades " +
            "are automated today; major version upgrades are not yet.",
    },
];

export interface Destination {
    readonly title: string;
    readonly detail: string;
    readonly href: string;
}

export const DESTINATIONS: readonly Destination[] = [
    {
        title: "Dry Run Mode",
        detail:
            "Point Dependency Sentinel at any package and see the dependencies and risks it " +
            "would report, without onboarding anything.",
        href: "/#/dry-run",
    },
    {
        title: "Teams",
        detail:
            "Browse an onboarded team's pipelines, packages, and the code reviews raised " +
            "against them.",
        href: "/#/team",
    },
    {
        title: LEADERSHIP_NAV_TITLE,
        detail:
            "Roll dependency risk up the management chain to see where it sits across an " +
            "org.",
        href: "/#/leadership-dashboard",
    },
];
